import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {MembershipStatusTranslationsService} from 'src/app/shared/translations';
import {CrmMembership} from '../../models';
import {CampaiMembership} from '../../models';
import {environment} from '~environments/environment';


/**
 * Service for creating and updating membership entity.
 */
@Injectable({
  providedIn: 'root'
})
export class MembershipService {
  public API_URL: any = environment.envAPI;
  public currentMembership: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public castCurrentMembership: any = this.currentMembership.asObservable();

  constructor(private http: HttpClient, private translations: MembershipStatusTranslationsService) {
  }

  /**
   * Get membership.
   */
  public getCrmMembership(customerId: number): Observable<CrmMembership> {
    return this.http.get<CrmMembership>(`${this.API_URL}/customers/${customerId}/membership`).pipe(
      map(res => new CrmMembership(res, this.translations))
    );
  }

  public getCampaiMembership(customerId: number): Observable<CampaiMembership> {
    return this.http.get<CampaiMembership>(`${this.API_URL}/customers/${customerId}/campai-membership`).pipe(
      map(res => new CampaiMembership(res, this.translations))
    );
  }

  public getCampaiMembershipStatus(customerId: number): Observable<CampaiMembership> {
    return this.http.get<CampaiMembership>(`${this.API_URL}/campai-contacts/${customerId}/status`).pipe(
      map(res => res)
    );
  }

  /**
   * Connect campai membership.
   */
  public createCampaiMembership(customerId: number): Observable<CampaiMembership> {
    return this.http.post<CampaiMembership>(`${this.API_URL}/campai-contacts`, {customerId});
  }

  /**
   * Create a new membership.
   */
  public create(membership: CrmMembership): Observable<CrmMembership> {
    return this.http.post<CrmMembership>(`${this.API_URL}/memberships`, membership).pipe(
      map(res => new CrmMembership(res, this.translations))
    );
  }

  /**
   * Update membership.
   */
  public update(membership: CrmMembership): Observable<CrmMembership> {
    return this.http.patch<CrmMembership>(`${this.API_URL}/memberships/${membership.id}`, membership).pipe(
      map(res => new CrmMembership(res, this.translations))
    );
  }

  /**
   * Delete membership.
   */
  public delete(membershipId: number): any {
    return this.http.delete(`${this.API_URL}/memberships/${membershipId}`);
  }

  /**
   * Adds values to the observer.
   */
  public announceCurrentMembership(membership: CrmMembership | CampaiMembership): void {
    this.currentMembership.next(membership);
  }

  /**
   * Clear the address values from the observable.
   */
  public clearCurrentMembership(): void {
    this.currentMembership.next(null);
  }
}
